import {globalVar} from '../universal';

/**
 * Automaticlly close window after media have toggled print mode and back.
 * Have fallback timer for browsers that don't print in window.
 */
const listenForPrintEnd = () => {
  let isPrintQuery = undefined;
  let timeout:any = 0;
  const close = () => {
    window.close();
    clearTimeout(timeout);
  };
  const afterprint = () => {
    /**
     * setTimeout is used to avoid Edge closes the window before the print dialog opens
     * and blocks the thread. This is also used to make sure android don´t close the window
     * before the print is done.
     */
    timeout = setTimeout(close, 200);
  };

  addEventListener('afterprint', afterprint);

  /**
   * If matchMedia is available listen for toggle of print media query.
   * This is used when chrome is printing, because it keeps the same window,
   * and switches the mediaquery to print makes the print and switches
   * back again.
   */
  if(globalVar('matchMedia')) {
    const mediaPrint = globalVar('matchMedia')('print');
    mediaPrint.addListener( (mql) => {
      // avoid afterprint and mediaquery battling.
      removeEventListener('afterprint', afterprint);
      if (isPrintQuery === true && mql.matches === false) {
        close();
      }
      isPrintQuery = mql.matches;
    });
  }
};

/**
 * A cross-device safe method to open print dialogs.
 */
export const triggerPrintDialog = () => {
  /**
   * Safari have a bug where it ignores window.print(), but it can trigger
   * the print dialog with execCommand.
   *
   * Chrome throws a error if you do it so it needs a try catch.
   * Firefox just returns false, so the if is used to call window.print after
   * execCommand is called.
   */
  try {
    if(document.execCommand('print', false, null)) {
      return;
    }
  } catch (e) {
    //tslint ignore
  }

  window.print();
};

/**
 * Workaround for printing dashboards - wait until charts are reflowed, after adding the "printing" class
 */
export const triggerPrintDialogForDashboards = () => {
  document.querySelector('.favourites-layout')?.classList.add('printing');
  const hasBowtie = document.querySelector('.bowtie-scene-canvas');
  if (hasBowtie) {
    window.dispatchEvent(new Event('resize'));
    setTimeout(() => {
        window.dispatchEvent(new Event('bowtie:prepare-print'));
        setTimeout(() => {
          window.print();
        }, 1000);
    }, 500);
  } else {
    setTimeout(() => {
      window.print();
    }, 1000);
  }
};

/**
 * A cross-device safe method to open print dialogs.
 * And close the window when printing is done.
 */
export const openPrintDialog = () => {
  listenForPrintEnd();

  /**
   * Additional debounce to avoid components not being completely rendered.
   * And to avoid afterprint being fired before listerens are initialized.
   */

  setTimeout(() => {
    triggerPrintDialog();
  }, 200);
};
